import { useCallback } from 'react'
import CertificationsService from '@/services/CertificationsService'
import TrainersService from '@/services/TrainersService'
import TrainingsService from '@/services/TrainingsService'
import UserService2 from '@/services/UserService2'

export default function useTrainingsApi() {
	const getAllTrainings = useCallback(options => TrainingsService.getAll(options), [])
	const searchTrainings = useCallback((searchText, options) => TrainingsService.search(searchText, options), [])
	const getTrainingById = useCallback(id => TrainingsService.getById(id), [])
	const createTraining = useCallback(payload => TrainingsService.create(payload), [])
	const updateTraining = useCallback((id, payload) => TrainingsService.update(id, payload), [])
	const deleteTraining = useCallback(id => TrainingsService.delete(id), [])
	const updateCompletionProofFiles = useCallback(
		(id, nextFiles, nextStatus = null) => TrainingsService.updateCompletionProofFiles(id, nextFiles, nextStatus),
		[]
	)
	const uploadTrainingFile = useCallback(
		(trainingId, file, onUploadProgress) => TrainingsService.uploadTrainingFile(trainingId, file, onUploadProgress),
		[]
	)
	const downloadTrainingFile = useCallback(
		(trainingId, fileUuid) => TrainingsService.downloadTrainingFile(trainingId, fileUuid),
		[]
	)
	const deleteTrainingFile = useCallback(
		(trainingId, fileUuid) => TrainingsService.deleteTrainingFile(trainingId, fileUuid),
		[]
	)
	const getAllCertifications = useCallback(options => CertificationsService.getAll(options), [])
	const getAllTrainingCatalog = useCallback(options => TrainingsService.getTrainingCatalog(options), [])
	const getContentOptions = useCallback(() => TrainingsService.getContentOptions(), [])
	const getAllTrainers = useCallback(options => TrainersService.getAll(options), [])
	const getTrainersForTraining = useCallback(options => UserService2.getTrainersForTraining(options), [])
	const updateTrainer = useCallback((id, payload) => TrainersService.update(id, payload), [])
	const updateTrainerUser = useCallback((id, payload) => UserService2.update(id, payload), [])

	return {
		createTraining,
		deleteTraining,
		getAllCertifications,
		getAllTrainers,
		getTrainersForTraining,
		getAllTrainingCatalog,
		getContentOptions,
		getAllTrainings,
		getTrainingById,
		searchTrainings,
		updateCompletionProofFiles,
		uploadTrainingFile,
		downloadTrainingFile,
		deleteTrainingFile,
		updateTrainer,
		updateTrainerUser,
		updateTraining,
	}
}
